import type { CSSProperties } from 'react';

export interface LoadingSpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingSpinner({ label = 'Loading…', size = 'md' }: LoadingSpinnerProps): JSX.Element {
  const diameter = size === 'sm' ? 18 : size === 'lg' ? 48 : 28;
  const borderWidth = size === 'lg' ? 4 : 3;

  const style: CSSProperties = {
    width: diameter,
    height: diameter,
    borderRadius: '50%',
    border: `${borderWidth}px solid var(--ink-200)`,
    borderTopColor: 'var(--pcb-blue)',
    animation: 'spin 0.8s linear infinite',
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--sp-5)' }}
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span style={style} aria-hidden />
      <span style={{ color: 'var(--ink-600)', fontSize: 13 }}>{label}</span>
    </div>
  );
}
